export const onDownload = (downloadLink) => {
  console.log('downloading');
  const link = document.createElement('a');
  link.download = `reporte.csv`;
  link.href = downloadLink;
  link.click();
};
